import { useQuery, type ApolloError } from '@apollo/react-hooks';
import { type GetApplicationNumbers, type AdvancedFilter } from './types';
import gql from 'graphql-tag';

const GET_APPLICATION_NUMBER = gql`
  query (
    $filter: NominationFilter
    $sort: NominationSort
    $paginator: PaginatorOptions
  ) {
    nominationsPaginated(filter: $filter, sort: $sort, paginator: $paginator) {
      paginator {
        count
      }
    }
  }
`;

export const useGetApplicationNumbers = (
  filters: AdvancedFilter[],
): GetApplicationNumbers => {
  const queries = filters.map(filter =>
    useQuery(GET_APPLICATION_NUMBER, { variables: { filter } }),
  );

  const results = queries.map(
    query => query?.data?.nominationsPaginated?.paginator?.count ?? 0,
  );

  const loading = queries.some(query => query.loading);
  const error = queries.find(query => query.error) as ApolloError | undefined;

  return { applicationNumbers: results, loading, error };
};
